//this file switches between Nav 3 and Nav 4 page-layout components. When Nav 4 is at 100% this file can simply be deleted and index can export nav 4 directly instead
import React from 'react';
import type { FC } from 'react';

import { LoadablePaint } from '@confluence/loadable';
import { useIsNav4Enabled } from '@confluence/nav4-enabled';

import type { PageLayoutProps } from './PageLayoutTypes';

const Nav3Layout = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Nav3-layout" */ './nav3/PageLayout')).PageLayout,
});

const Nav4Layout = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Nav4-layout" */ './PageLayout')).PageLayout,
});

export const PageLayout: FC<PageLayoutProps> = (props) => {
	const isNav4Enabled = useIsNav4Enabled();
	return isNav4Enabled ? <Nav4Layout {...props} /> : <Nav3Layout {...props} />;
};
